import { observer } from "mobx-react-lite";

import { ImportApplicationButton } from "../../../components/import-application";
import { usePageStore } from "../applications-page.lib";

export const ApplicationsImportButton = observer(() => {
  const store = usePageStore();

  return <ImportApplicationButton onOpen={() => store?.setPopupAction({ type: "import-application" })} />;
});
